import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import { putNotesFailure, putNotesSuccess } from "../slices/features/postNote";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* putNoteSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.putNotes,
      baseUrl,
      id,
      data
    );

    yield put(putNotesSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(putNotesFailure({ statusCode, statusText }));
  }
}

export function* watchPutNotes() {
  yield takeLatest(RequestTypes.PUT_NOTE_REQUEST, putNoteSaga);
}
